<template lang="html">
    <svg class="inline-icon-sw-quality" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
        <path :fill="color" d="M12,2C6.48,2,2,6.48,2,12c0,5.521,4.48,10.001,10,10.001S22,17.521,22,12C22,6.48,17.52,2,12,2z
        M13.67,14.542c0-0.383-0.137-0.69-0.408-0.923c-0.271-0.232-0.746-0.451-1.425-0.656c-1.185-0.342-2.081-0.747-2.687-1.217
        c-0.605-0.469-0.909-1.112-0.909-1.928s0.348-1.482,1.042-2c0.695-0.517,1.583-0.776,2.663-0.776c1.094,0,1.985,0.291,2.673,0.872
        c0.689,0.581,1.021,1.298,0.998,2.15l-0.014,0.041H13.67c0-0.46-0.154-0.833-0.463-1.118c-0.307-0.285-0.738-0.427-1.295-0.427
        c-0.533,0-0.945,0.119-1.237,0.355s-0.438,0.54-0.438,0.909c0,0.337,0.156,0.614,0.468,0.831c0.313,0.216,0.852,0.445,1.617,0.687
        c1.1,0.305,1.93,0.709,2.496,1.21c0.564,0.501,0.848,1.159,0.848,1.976c0,0.852-0.336,1.524-1.008,2.017
        c-0.674,0.492-1.561,0.738-2.664,0.738c-1.084,0-2.03-0.279-2.837-0.837c-0.807-0.559-1.198-1.342-1.176-2.349l0.014-0.041h1.941
        c0,0.593,0.181,1.026,0.544,1.302c0.361,0.276,0.867,0.414,1.514,0.414c0.543,0,0.957-0.111,1.244-0.335S13.67,14.915,13.67,14.542z"/>
    </svg>
</template>

<script>
import { navIcon } from '@/functions/appColors';

export default {
    props: {
        color: {
            default: String(navIcon),
            type: String,
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/icons/SwQuality.vue